import { distanceLabel } from "@vidario/domain";
import { MapPin } from "lucide-react";
import { type ReactElement } from "react";

import { cn } from "../utils/cn";

export interface DistanceChipProps {
  km: number;
  /** The job's Standort as stored; the chip names only its town (#163). */
  jobLocation?: string | null;
  /** In the Anonym-Ansicht a short distance would point at the candidate's town (#146). */
  anonym?: boolean;
  className?: string;
}

const TONES = {
  same: "border-success-200 bg-success-50 text-success-700",
  near: "border-neutral-200 bg-neutral-100 text-neutral-700",
  far: "border-warning-200 bg-warning-50 text-warning-700",
} as const;

export function DistanceChip({
  km,
  jobLocation,
  anonym = false,
  className,
}: DistanceChipProps): ReactElement {
  const label = distanceLabel(km, jobLocation, { anonym });
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium",
        TONES[label.tone],
        className,
      )}
    >
      <MapPin size={10} aria-hidden="true" />
      <span aria-hidden="true">{label.text}</span>
      <span className="sr-only">{label.spoken}</span>
    </span>
  );
}
